// biome-ignore lint/correctness/noUnusedImports: legacy import, will be migrated
import React from 'react';

import MainFooter from '@crehana/web/MainFooter';

import { useHideBannerDownloadApp } from '../hooks/use-hide-banner-download-app';

export const WrapperMainFooter = () => {
  const { hideBannerDownloadAppCrehana } = useHideBannerDownloadApp();

  return <MainFooter shouldHideAppsColumn={hideBannerDownloadAppCrehana} />;
};
